export default __webpack_public_path__ + "static/media/deliciaabacaxi.e2e91d37.jpg";